'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5 v-for="item in categoryList" v-if="item.code == typeCode">{{item.name}}</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 - </router-link>
         <template v-if="rCode == ''">
            <a v-for="item in categoryList" v-if="item.code == typeCode">{{item.name}}</a>
         </template>
         <template v-else>
            <router-link :to="'/list/'+typeCode" v-for="item in categoryList" v-if="item.code == typeCode">{{item.name}}
               - </router-link>
            <a v-for="item in leftCateList" v-if="item.code == rCode">{{item.name}}</a>
         </template>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item" :class="item.code == rCode ?'active':''" v-for="(item,index) in leftCateList">
                     <router-link :to="'/list/'+typeCode +'?rCode='+item.code">
                        {{item.name}} <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
            </div>
            <div class="list_right" v-loading="loading">
               <template v-if="list.length > 0">
                  <ul class="right_list">
                     <li v-for="(item,index) in list">
                        <div v-if="item.isOutLink=='N'">
                           <router-link :to="'/list/'+typeCode+'/info/'+item.code+'?rCode='+rCode">
                              <h5 class="l_title">{{item.title}}</h5>
                              <span class="l_date">{{(item.createTime).slice(0,10)}}</span>
                           </router-link>
                        </div>

                        <a :href="item.outLinkUrl" v-if="item.isOutLink=='Y'" target="_blank">
                           <h5 class="l_title">{{item.title}}</h5>
                           <span class="l_date">{{(item.createTime).slice(0,10)}}</span>
                        </a>
                     </li>
                  </ul>

                  <div class="list_pages">
                     <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount"
                        @current-change="handleCurrentChange">
                     </el-pagination>
                  </div>
               </template>
               <el-empty description="暂无内容" v-else></el-empty>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'list_page',
      components: {},
      data() {
         return {
            loading: true,
            typeCode: '', ///分类code
            rCode: '',
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,
            categoryList: [], //顶级分类
            leftCateList: [],
            list: [],
         };
      },
      watch: {
         $route() {

         },
         '$route.query.rCode': {
            handler(newVal, oldVal) {
               //判断newVal有没有值监听路由变化
               if (this.$route.query.rCode) {
                  this.rCode = this.$route.query.rCode;
               } else {
                  this.rCode = '';
               }
               this.pageNum = 1;
               this.categoryList.forEach(e => {
                  if (this.rCode != '') {
                     if (e.code == this.rCode) {
                        document.title = e.name + ' ' + process.env.VUE_APP_TITLE;
                     }
                  } else if (e.code == this.typeCode) {
                     document.title = e.name + ' ' + process.env.VUE_APP_TITLE;
                  }
               })
               this.getlist();
            },
            deep: true
         }
      },
      mounted() {
         this.typeCode = this.$route.params.type;
         if (this.$route.query.rCode) {
            this.rCode = this.$route.query.rCode
         }
         this.getCategoryList('', 1);
         this.getlist();
      },
      methods: {
         getCategoryList(code, type) {
            var _this = this;
            _this.$api.categoryList({
               parentCode: code,
            }).then(res => {
               if (res.code == 200) {
                  if (type == 1) {
                     _this.categoryList = res.data;
                     _this.getCategoryList(_this.typeCode, 2);
                     _this.categoryList.forEach(e => {
                        if (this.rCode != '') {
                           if (e.code == this.rCode) {
                              document.title = e.name + ' ' + process.env.VUE_APP_TITLE;
                           }
                        } else if (e.code == this.typeCode) {
                           document.title = e.name + ' ' + process.env.VUE_APP_TITLE;
                        }
                     })
                  } else {
                     if (res.data.length > 0) {
                        _this.leftCateList = res.data;
                     } else {
                        _this.categoryList.forEach(e => {
                           if (e.code == this.typeCode) {
                              _this.leftCateList.push(e);
                           }
                        })
                     }
                  }
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },
         getlist() {
            var _this = this,
               code = '';
            _this.loading = true;
            if (this.rCode != '') {
               code = this.rCode;
            } else {
               code = this.typeCode;
            }
            _this.$api.artList({
               categoryCode: code,
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         }
      }
   }
</script>
<style lang="less" scoped>

</style>